








































import { UiButton, UiIconButton, UiTextbox } from '../keen-ui';

import { DeviceEnum, KeyboardCodeEnum } from '../../enums';

export default {
  name: 'keywords-input',
  components: {
    UiTextbox,
    UiButton,
    UiIconButton
  },
  props: {
    values: Array,
    maxLength: Number,
    help: String,
    tooltip: String,
    disabled: Boolean
  },
  data: function () {
    return {
      DeviceEnum,
      value: ''
    };
  },
  methods: {
    onInputKeydown: function (keyboardEvent: KeyboardEvent): void {
      if ((keyboardEvent.key === KeyboardCodeEnum.ENTER) || keyboardEvent.key === ';') {
        this.addValue();
        keyboardEvent.preventDefault();
      }
    },
    addValue: function (): void {
      const values: string[] = this.value.split(';');
      values.forEach((value: string) => {
        value = value.trim();
        if (!!value && (this.values.indexOf(value) < 0)) {
          this.values.push(value);
          this.value = '';
        }
      });
    },
    removeValue: function (value: string): void {
      this.values.splice(this.values.indexOf(value), 1);
    }
  }
};

